module.exports = __webpack_public_path__ + "img/parallax-livebruhs.c132bb08.png";